import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FechaFinFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='FECHA FIN' htmlFor='date-fechaFin' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='fechaFin'>
          {({ field }) => (
            <Form.InputDate {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='date-fechaFin' />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaFinFormGroup)
